import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ChevronRight } from "lucide-react";
import { api } from "../../lib/api";
import { useT } from "../../lib/i18n";
import { Input } from "../../components/ui/input";
import PublicFrame from "../public/PublicFrame";

const TXT = {
  en: { title: "Create your patient account", sub: "Find your clinic to create an account and see your appointments and forms.", ph: "Type your clinic's name or town", none: "No clinic found" },
  it: { title: "Crea il tuo account paziente", sub: "Cerca la tua clinica per creare un account e vedere appuntamenti e moduli.", ph: "Scrivi il nome della clinica o la città", none: "Nessuna clinica trovata" },
};

export default function PatientStart() {
  const { lang } = useT();
  const l = TXT[lang] || TXT.en;
  const [q, setQ] = useState("");
  const [list, setList] = useState(null);

  useEffect(() => {
    if (q.trim().length < 2) { setList(null); return undefined; }
    const h = setTimeout(() => { api.get("/public/clinics", { params: { q } }).then((r) => setList(r.data)); }, 250);
    return () => clearTimeout(h);
  }, [q]);

  return (
    <PublicFrame>
      <div className="space-y-6 max-w-md" data-testid="patient-start">
        <div><h1 className="text-3xl sm:text-4xl font-bold">{l.title}</h1><p className="text-muted-foreground mt-2">{l.sub}</p></div>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input data-testid="clinic-search-input" className="pl-9" placeholder={l.ph} value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        {list && !list.length && <p className="text-sm text-muted-foreground" data-testid="clinic-search-empty">{l.none}</p>}
        <div className="space-y-2">
          {list?.map((c) => (
            <Link key={c.slug} to={`/p/${c.slug}?mode=register`} data-testid={`clinic-result-${c.slug}`}
              className="flex items-center justify-between rounded-[var(--radius)] border bg-card p-4 hover:border-primary transition-colors">
              <span className="min-w-0"><span className="block font-medium">{c.name}</span>
                {c.locations?.length > 0 && <span className="block text-xs text-muted-foreground truncate" data-testid={`clinic-result-locations-${c.slug}`}>{c.locations.join(" · ")}</span>}</span>
              <ChevronRight className="h-4 w-4 shrink-0 text-primary" />
            </Link>
          ))}
        </div>
      </div>
    </PublicFrame>
  );
}
